import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { TenantUserEffects } from './tenant-user.effects';
import { initialState, reducer } from './tenant-user.reducer';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature('tenantUser', reducer, { initialState }),
    EffectsModule.forFeature([TenantUserEffects]),
  ],
  providers: [TenantUserEffects],
})
export class TenantUserStoreModule {}
